import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { id: "moneyRain" }

import { ref, onMounted, onBeforeUnmount } from 'vue';

interface MoneyItem {
  id: number;
  type: string;
  style: Record<string, string>;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'rainCoinOverlay',
  setup(__props) {

const moneyList = ref<MoneyItem[]>([]);
const moneyTypes = [''];
let idCounter = 0;
let spawnInterval: number;

function spawnMoney() {
  const type = moneyTypes[Math.floor(Math.random() * moneyTypes.length)];
  const left = Math.random() * 2000;
  const delay = 0;
  const duration = 2 + Math.random() * 10; // 6s to 10s
  const rotation = Math.random() > 0.5 ? 720 : -720;

  const item: MoneyItem = {
    id: idCounter++,
    type,
    style: {
      left: `${left}vw`,
      animationDelay: `${delay}s`,
      animationDuration: `${duration}s`,
      '--rotation': `${rotation}deg`,
    },
  };

  moneyList.value.push(item);

  // Remove item after animation finishes
  setTimeout(() => {
    moneyList.value = moneyList.value.filter(i => i.id !== item.id);
  }, duration * 1000);
}

onMounted(() => {
  spawnInterval = window.setInterval(() => {
    for (let i = 0; i < 15; i++) {
      spawnMoney();
    }
  }, 100); // Add 3 every 300ms
});

onBeforeUnmount(() => {
  clearInterval(spawnInterval);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(moneyList.value, (item) => {
      return (_openBlock(), _createElementBlock("div", {
        key: item.id,
        class: _normalizeClass(['money', item.type]),
        style: _normalizeStyle(item.style)
      }, _cache[0] || (_cache[0] = [
        _createElementVNode("div", { class: "sprite-animation" }, null, -1)
      ]), 6))
    }), 128))
  ]))
}
}

})